export default __webpack_public_path__ + "static/media/sapphire7.04416078.jpg";